/**
 * The city's news feed (owner's idea: real happenings on the radio and the billboards). Game code reports a happening
 * with `report()`; the feed keeps the latest few with where and when; Sprawl FM reads them in its bulletins, the digital
 * billboards show the newest, the server sends the feed to clients when it changes. Templates live in content/radio
 * (kind `headline`, one file per happening kind) so the wording is content, not code.
 */
import type { Game } from './game';

export type NewsKind = 'robbery' | 'bank' | 'bought' | 'turf' | 'race' | 'wanted' | 'explosion' | 'crash' | 'grounded' | 'show' | 'fire' | 'rescue' | 'joined' | 'left' | 'weather' | 'camera' | 'area69';
export interface NewsItem { id: number; /** game time it happened */ t: number; day: number; hour: number; kind: NewsKind; /** the headline, ready to read */ text: string; x: number; y: number; /** who (a player's name) */ who?: string }
export const NEWS_KEEP = 24;

/** File a happening. `fill` are the placeholders the kind's templates use ({who}, {place}, {town}, {what}, {n}). */
export function report(game: Game, kind: NewsKind, x: number, y: number, fill: Record<string, string | number>, who?: string): NewsItem | undefined {
  const town = game.world.gen.fields.settlements.in(x, y)?.name ?? 'the outskirts';
  const zone = game.world.gen.fields.urbanZone(x, y);
  const templates = game.reg.all('radio').filter((r) => r.kind === 'headline' && r.tags.includes(kind));
  const lines = templates.flatMap((r) => r.lines);
  if (!lines.length) return undefined;
  const rng = ((game.time * 1000) | 0) ^ (x | 0) ^ ((y | 0) << 8);
  const line = lines[Math.abs(rng) % lines.length];
  const text = line.replace(/\{(\w+)\}/g, (_, k: string) => String(k === 'town' ? town : k === 'zone' ? zone : k === 'who' ? who ?? 'somebody' : fill[k] ?? `{${k}}`));
  const item: NewsItem = { id: game.newsNext++, t: game.time, day: game.day, hour: game.hour, kind, text, x: Math.round(x), y: Math.round(y), who };
  game.news.push(item);
  if (game.news.length > NEWS_KEEP) game.news.splice(0, game.news.length - NEWS_KEEP);
  game.newsVersion++;
  return item;
}
/** The newest headline, for a billboard */
export function latestNews(game: { news: NewsItem[] }): NewsItem | undefined { return game.news[game.news.length - 1]; }
